import { render, staticRenderFns } from "./SoftwareForm.vue?vue&type=template&id=04180d85&"
import script from "./SoftwareForm.vue?vue&type=script&lang=js&"
export * from "./SoftwareForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports